export const TipoRiegoArray =[
    {id:'B',display:'BOMBEO'},
    {id:'G',display:'GOTEO'},
    {id:'R',display:'RODADO'},
]